import { ApiDateSchema, CONTRACT_TYPES, ContractTypeSchema, ObjectIdSchema } from '@vy/types';
import { oz } from '@vy/utils';

export const AssignCustomerFormSchema = oz.object({
  customerId: ObjectIdSchema,
  startDate: ApiDateSchema.optional(),
  contractType: ContractTypeSchema.default(CONTRACT_TYPES.Standard),
});

export const AssignCustomerFormFullRequiredSchema = AssignCustomerFormSchema.required();

export type AssignCustomerForm = oz.infer<typeof AssignCustomerFormSchema>;
export type AssignCustomerFullRequiredForm = oz.infer<typeof AssignCustomerFormFullRequiredSchema>;
